import { RUNTIME_ENVIRONMENT } from 'src/dataLayer/env';
import { CaptchaConfig } from 'src/viewLayer/components/nodes/InputNode/Captcha/types';

export const DEFAULT_CAPTCHA_CONFIG: CaptchaConfig = {
  sitekey: RUNTIME_ENVIRONMENT === 'production' ? '486c253b-ae06-4294-88f0-8631461a7774' : '671faaa0-d2d1-4ffc-9817-4e68417c957a',
  provider: 'hcaptcha'
};
